//
// Sand-garden color tokens for the /contact WebGL scene. Hex is the source;
// sandVec3() emits GLSL vec3 literals so shaders never carry raw hex.

export const sand = {
  // Desaturated, multi-tone sand. Real sand is greyish tan / warm beige, not a
  // single saturated gold — these tones sit low on the saturation axis and the
  // shader noise-mixes mid/mid2 so the field never reads as one flat hue.
  crest:      { hex: '#e7dfce', role: 'Lit sand crest (warm off-white)' },
  mid:        { hex: '#cdc3ac', role: 'Mid sand tone (greige)' },
  mid2:       { hex: '#c2bba6', role: 'Second mid tone — cooler, for noise mix' },
  trough:     { hex: '#9a8f78', role: 'Shadowed groove trough (muted taupe)' },
  keyLight:   { hex: '#fbf6ec', role: 'Near-neutral warm key light' },
  ambient:    { hex: '#c5bfb1', role: 'Cool ambient fill' },
  stoneBody:  { hex: '#7b756a', role: 'Stone body (mid granite — not a void)' },
  stoneKey:   { hex: '#aaa393', role: 'Stone top-left key highlight' },
  stoneRim:   { hex: '#9aa4ae', role: 'Stone cool sky rim light' },
  stoneUnder: { hex: '#6a5f4d', role: 'Stone warm underside bounce' },
  aoTint:     { hex: '#7d7159', role: 'Contact-shadow AO tint under stones' },
} as const;

export type SandKey = keyof typeof sand;

export function sandVec3(key: SandKey): string {
  const hex = sand[key].hex.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;
  return `vec3(${r.toFixed(4)}, ${g.toFixed(4)}, ${b.toFixed(4)})`;
}
